import { Identity } from '@/types/bio-section'
// import { ImportDataType } from '@/services/tag/types'
type ImportDataType = any
import { BioSectionTypes } from '@/types/bio-section'
import { ReactNode, createContext, useState } from 'react'

/* eslint-disable react-refresh/only-export-components -- context module */

export type DataMapperContext = {
    selectedIdentity?: Identity | null
    handleSelectIdentity: (arg: Identity | null) => void
    step?: number
    selectedBioSectionType: BioSectionTypes | null
    handleSelectBioType: (arg: BioSectionTypes | null) => void
    contentValue?: string | null
    setContentValue: (arg: string | null | undefined) => void
    resetMapper: () => void
    openModal: boolean
    setOpenModal: (arg: boolean) => void
    mapData?: ImportDataType | null
    setMapData: (arg: ImportDataType | null | undefined) => void
}

const defaultValues: DataMapperContext = {
    selectedIdentity: undefined,
    handleSelectIdentity: () => undefined,
    step: undefined,
    selectedBioSectionType: null,
    handleSelectBioType: () => undefined,
    contentValue: undefined,
    setContentValue: () => undefined,
    resetMapper: () => undefined,
    openModal: false,
    setOpenModal: () => undefined,
    mapData: undefined,
    setMapData: () => undefined,
}

export const DataMapperContext = createContext(defaultValues)

export function ImportDataProvider({ children }: { children: ReactNode }) {
    const [step, setStep] = useState(1)
    const [selectedIdentity, setSelectedIdentity] = useState<Identity | undefined | null>()
    const [selectedBioSectionType, setSelectedBioSectionType] = useState<BioSectionTypes | null>(null)
    const [contentValue, setContentValue] = useState<string | null | undefined>()
    const [openModal, setOpenModal] = useState(false)
    const [mapData, setMapData] = useState<ImportDataType | null | undefined>(null)

    const handleSelectIdentity = (identity: Identity | null) => {
        setSelectedIdentity(identity)
        setStep(identity ? 2 : 1)
    }

    const handleSelectBioType = (bioType: BioSectionTypes | null) => {
        setSelectedBioSectionType(bioType)
        setStep(bioType ? 3 : 2)
    }

    const resetMapper = () => {
        setStep(1)
        setSelectedBioSectionType(null)
        setSelectedIdentity(null)
        setContentValue(null)
        // setOpenModal(false)
    }

    return (
        <DataMapperContext.Provider
            value={{
                handleSelectIdentity,
                selectedIdentity,
                step,
                selectedBioSectionType,
                handleSelectBioType,
                contentValue,
                setContentValue,
                resetMapper,
                openModal,
                setOpenModal,
                mapData,
                setMapData,
            }}
        >
            {children}
        </DataMapperContext.Provider>
    )
}
